<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import { authComputed } from '@/state/helpers'
export default {
  name: 'shared.shipping.step',

  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      enable_shipping: 'no',
      shipping_address_id: null,
      ...vm.value
    }
  }),
  computed: {
    ...authComputed
  },
  validations: {
    form: {
      shipping_address_id: {
        required: requiredIf(model => {
          return model.enable_shipping === 'yes'
        })
      }
    }
  },
  mounted () {
    if (this.userProfile.preferences.enable_shipping_by_default)
      this.form.enable_shipping = 'yes'
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', {
          ...this.form,
          enable_shipping: this.form.enable_shipping === 'yes',
          shipping_address_id:
            this.form.enable_shipping === 'yes'
              ? this.form.shipping_address_id
              : null
        })
        this.$emit('input', {
          ...this.form,
          enable_shipping: this.form.enable_shipping === 'yes',
          shipping_address_id:
            this.form.enable_shipping === 'yes'
              ? this.form.shipping_address_id
              : null
        })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <b-row>
    <b-col cols="12">
      <g-radio-group
        label="Shipping"
        label-for="order_status"
        label-cols-md="4"
        label-cols-xl="3"
        class="align-items-center"
        v-model="form.enable_shipping"
        :options="[
          { value: 'yes', text: 'Yes, Ship this order' },
          { value: 'no', text: 'No, I will pick it up' }
        ]"
        button-variant="outline-primary"
      >
      </g-radio-group>

      <b-form-group
        label-cols-md="4"
        label-cols-xl="3"
        label-for="shipping_address_id"
      >
        <template v-slot:label>
          <div class="d-flex align-items-center">Shipping Address</div>
        </template>
        <app-address-select
          id="shipping_address_id"
          open-direction="above"
          style="min-width: 500px"
          :disabled="form.enable_shipping !== 'yes'"
          v-model="form.shipping_address_id"
          :customerId="userProfile.customer_account_id"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>
